var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationIconGameUpdateImpacts({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24px-game-update-impacts-01") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.71,5.29l-3-3a1,1,0,0,0-1.42,0l-3,3a1,1,0,0,0,1.42,1.42L18,5.42c0,6.82-.88,9.1-6,9.5V2a1,1,0,0,0-2,0V15H2a1,1,0,0,0,0,2h8v5a1,1,0,0,0,2,0V16.91c6.69-.54,8-4,8-11.5l1.29,1.3a1,1,0,0,0,1.42,0A1,1,0,0,0,22.71,5.29Z",
    fill: "#343434"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationIconGameUpdateImpacts);
export default __webpack_public_path__ + "static/media/navigation-icon-game-update-impacts.167745edb16976df231edf31f9ec7bf5.svg";
export { ForwardRef as ReactComponent };